<script>
  import { cart, stage, formdata, user, Stages, formStorageKey, deliveryServices, lockerPoint } from './storage.js';
  import Textfield from '@smui/textfield';
  import BillingAddress from './BillingAddress.svelte';
  import DeliveryAddress from './DeliveryAddress.svelte';
  import BasicData from './BasicData.svelte';
  import InpostGeowidget from './InpostGeowidget.svelte';
  import Modal from './Modal.svelte';

  let comment = $state($formdata?.comment || '');
  let sameAddress = $state(true);
  let showComment = $state($formdata?.comment ? true : false);

  let basicData = $state({
    email: $formdata?.email || $user?.email || '',
    phone: $formdata?.phone || '',
  });
  let basicDataValid = $state(false);
  let billingAddress = $state({
    b2b: $formdata?.billing_address_attributes?.b2b || false,
    tax_id: $formdata?.tax_id || '',
    first_name: $formdata?.billing_address_attributes?.first_name || '',
    last_name: $formdata?.billing_address_attributes?.last_name || '',
    company_name: $formdata?.billing_address_attributes?.company_name || '',
    street: $formdata?.billing_address_attributes?.street || '',
    building: $formdata?.billing_address_attributes?.building || '',
    apartment: $formdata?.billing_address_attributes?.apartment || null,
    city: $formdata?.billing_address_attributes?.city || '',
    zipcode: $formdata?.billing_address_attributes?.zipcode || '',
    country: 'pl',
  });
  let billingAddressValid = $state(false);
  let deliveryAddress = $state({
    first_name: $formdata?.delivery_address_attributes?.first_name || '',
    last_name: $formdata?.delivery_address_attributes?.last_name || '',
    street: $formdata?.delivery_address_attributes?.street || '',
    building: $formdata?.delivery_address_attributes?.building || '',
    apartment: $formdata?.delivery_address_attributes?.apartment || null,
    city: $formdata?.delivery_address_attributes?.city || '',
    zipcode: $formdata?.delivery_address_attributes?.zipcode || '',
    country: 'pl',
  });
  let deliveryAddressValid = $state(true);

  let selectedDeliveryService = $derived(
    ($deliveryServices || []).find(s => s.id === $cart?.delivery_service_id)
  );
  let needsDeliveryAddress = $derived(
    !$cart?.no_delivery && selectedDeliveryService?.requires_delivery_address !== false
  );
  let isInpostLocker = $derived(selectedDeliveryService?.type === 'DeliveryService::InpostLocker' && !$cart?.no_delivery);

  let showLockerModal = $state(false);
  let attemptCount = $state(0);

  const handleLockerSelect = ({ name, address }) => {
    $lockerPoint = { name, address };
    showLockerModal = false;
  };

  function sanitizeComment(str) {
    if (!str) return '';
    return str
      .replace(/<[^>]*>/g, '')
      .trim();
  }

  const submitForm = () => {
    if (!basicDataValid || !billingAddressValid || !deliveryAddressValid) {
      attemptCount++;
      return;
    }

    if (!billingAddress.b2b) {
      billingAddress.tax_id = null;
      billingAddress.company_name = null;
    }

    let payload = {
      billing_address_attributes: {...billingAddress},
      comment: sanitizeComment(comment),
      ...basicData
    }

    if (billingAddress.b2b) {
      payload.invoice = true;
      payload.tax_id = billingAddress.tax_id;
      
      if (!billingAddress.first_name) {
        delete payload.billing_address_attributes.first_name;
      }

      if (!billingAddress.last_name) {
        delete payload.billing_address_attributes.last_name;
      }
    }

    delete payload.billing_address_attributes.tax_id;

    if (!sameAddress) {
      payload.delivery_address_attributes = {...deliveryAddress};
    }

    if ($user) {
      payload.user_id = $user.id;
    }

    $formdata = payload;
    localStorage.setItem(formStorageKey($cart.token), JSON.stringify($formdata));
    $stage = Stages.SUMMARY;
  }
</script>

<h1>Formularz zamówienia</h1>

<section style="margin-top: 40px;">
  <h3>Dane kontaktowe</h3>
  <BasicData bind:fields={basicData} bind:valid={basicDataValid} {attemptCount} />
</section>

<section style="margin-top: 40px;">
  <h3>Adres rozliczeniowy</h3>
  <BillingAddress bind:fields={billingAddress} bind:valid={billingAddressValid} {attemptCount} />
</section>

{#if isInpostLocker}
  <section style="margin-top: 40px;">
    <h3>Dostawa do paczkomatu</h3>
    {#if $lockerPoint}
      <p class="locker-name">{$lockerPoint.name}</p>
      <p class="locker-address">{$lockerPoint.address}</p>
      <a class="locker-change" role="button" tabindex="0"
         onclick={() => showLockerModal = true}
         onkeydown={(e) => e.key === 'Enter' && (showLockerModal = true)}>wybierz inny</a>
    {:else}
      <a class="locker-change" role="button" tabindex="0"
         onclick={() => showLockerModal = true}
         onkeydown={(e) => e.key === 'Enter' && (showLockerModal = true)}>
        Wybierz paczkomat &rsaquo;
      </a>
    {/if}
  </section>
{/if}

{#if needsDeliveryAddress}
  <section style="margin-top: 40px;">
    <h3>Adres dostawy</h3>
    <DeliveryAddress bind:fields={deliveryAddress} bind:valid={deliveryAddressValid} bind:sameAddress {attemptCount} />
  </section>
{/if}

{#if showLockerModal}
  <Modal onclose={() => showLockerModal = false} wide>
    <InpostGeowidget
      token={selectedDeliveryService.geowidget_token}
      baseUrl={selectedDeliveryService.geowidget_base_url}
      onselect={handleLockerSelect}
    />
  </Modal>
{/if}

<section class="comment-section" style="margin-top: 40px;">
  {#if !showComment}
    <!-- svelte-ignore a11y_missing_attribute -->
    <a class="promocode__trigger" role="button" tabindex="0" onclick={() => showComment = true} onkeydown={(e) => e.key === 'Enter' && (showComment = true)}>+ Chcę dołączyć dodatkowe informacje</a>
  {:else}
    <h3>Dodatkowe informacje</h3>
    <div class="row row-1">
      <Textfield bind:value={comment}
        textarea
        style="width: 100%;"
        helperLine$style="width: 100%;"
        label="Twoje uwagi">
      </Textfield>
    </div>
  {/if}
</section>

<div class="actions">
  <div class="actions-right">
    <button class="button" class:button--pending={!basicDataValid || !billingAddressValid || !deliveryAddressValid} onclick={submitForm}>Przejdź do podsumowania</button>
  </div>
</div>


<style>
  .locker-name {
    font-weight: bold;
    margin: 0 0 2px;
  }

  .locker-address {
    font-size: 0.85em;
    color: #555;
    margin: 0 0 6px;
  }

  .locker-change {
    font-size: 0.85em;
    cursor: pointer;
  }

  button.button--pending {
    opacity: 0.55;
    cursor: default;
    filter: grayscale(25%);
  }

</style>
